//* Members Match Details Controller
//*
//* Fills the shared match-details modal (#matchDetailsModal) from a clicked
//* match ring's data attributes: the member's name in the header, then the
//* checked filter criteria — ticks for what the member offers, crosses for
//* what it's missing. The modal itself opens via the ring's Bootstrap
//* data API; this controller only populates it.
import ApplicationController from "application_controller.js";

export default class extends ApplicationController {
  debug = false;

  static targets = ["title", "list", "tickIcon", "crossIcon"];

  open(event) {
    const ring = event.currentTarget;
    this.titleTarget.textContent = ring.dataset.matchName;

    let details;
    try {
      details = JSON.parse(ring.dataset.matchDetails) || [];
    } catch {
      details = [];
    }

    this.listTarget.replaceChildren(
      ...details.filter((detail) => detail.matched).map((detail) => this.listItem(detail)),
      ...details.filter((detail) => !detail.matched).map((detail) => this.listItem(detail)),
    );
  }

  listItem({ label, matched }) {
    const item = document.createElement("li");
    item.className = "d-flex align-items-center gap-2";
    item.append((matched ? this.tickIconTarget : this.crossIconTarget).content.cloneNode(true));

    const text = document.createElement("span");
    text.textContent = label;
    item.append(text);

    return item;
  }
}
